<template>
  <div class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <p>© {{poweredBy}}</p>
        </div>
        <div class="col-md-6">
          <div class="store_link">
            <a href="#"></a>
            <a href="#"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      poweredBy: ""
    };
  },
  mounted() {
    setTimeout(
      () => (this.poweredBy = localStorage.getItem("poweredBy")),
      1000
    );
  }
};
</script>
